<div class="arquivo-table">
    <table class="table table-striped table-hover table-bordered" [id]="idTable">
        <thead>
            <tr>
                <th class="col-select text-center">
                    <input type="checkbox" [ngModel]="selectedAll" (ngModelChange)="toggleSelectedAll($event)" name="arquivoSelectedAll" id="arquivoSelectedAll">
                </th>
                <th class="col-options"></th>
                <th class="col-nome">Nome</th>
                <th class="col-tipo">Tipo</th>
                <th class="col-usuario-created">Adicionado Por</th>
                <th class="col-created-at text-center">Adicionado Em</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="5" class="text-center">
                    {{total?.quantidade | decimalFormat: 1:0:0}} arquivo(s)
                </td>
            </tr>
        </tfoot>    
    </table>
</div>

<ng-template #avatarContainer></ng-template>